import { Box, TextField } from "@mui/material";

const StepTwo = ({ formData, handleContentChange }) => {
  return (
    <Box className="mt-3">
      <TextField
        margin="dense"
        label="Content Title"
        value={formData.content?.title || ""}
        onChange={(e) => handleContentChange("title", e.target.value)}
        fullWidth
      />
      <TextField
        margin="dense"
        label="Content Description"
        value={formData.content?.description || ""}
        onChange={(e) => handleContentChange("description", e.target.value)}
        fullWidth
        multiline
        rows={3}
      />
    </Box>
  );
};
export default StepTwo;
